import {
  createCommunityRequest,
  deleteCommunityRequest,
  editCommunityRequest,
  fetchCertainCommunityRequest,
  fetchCommunitiesRequest,
} from 'api';
import { PaginationType } from 'common';
import { Pagination, Roles } from 'enums';
import {
  setCertainCommunity,
  setCommunities,
  setCommunitiesAfterScroll,
  setCommunitiesPagination,
  setCommunitiesLoadingStatus,
  setNotification,
  setUserInfo,
  setAuthLoading,
} from 'state/actions';
import { AppRootStateType } from 'state/reducers';
import { TypedDispatch } from 'state/types';
import { addCommunityToLocalAdmin } from 'utils/workWithLS';

export const fetchCommunities =
  (isScroll: boolean) =>
  async (dispatch: TypedDispatch, getState: () => AppRootStateType) => {
    const { page, search } = {
      page: isScroll ? getState().communities.page : Pagination.START_PAGE,
      search: getState().communities.search.trim(),
    };

    try {
      dispatch(setCommunitiesLoadingStatus(true));
      const response = await fetchCommunitiesRequest({
        page,
        q: search || undefined,
        take: Pagination.TAKE,
      });
      const pagination: PaginationType = {
        page: response?.data.page,
        count: response?.data.count,
      };

      dispatch(setCommunitiesPagination(pagination));
      dispatch(
        isScroll
          ? setCommunitiesAfterScroll(response?.data.rows)
          : setCommunities(response?.data.rows),
      );
    } finally {
      dispatch(setCommunitiesLoadingStatus(false));
    }
  };

export const fetchCertainCommunity = (id: string) => async (dispatch: TypedDispatch) => {
  try {
    dispatch(setCommunitiesLoadingStatus(true));
    const response = await fetchCertainCommunityRequest(id);

    dispatch(setCertainCommunity(response?.data));
  } finally {
    dispatch(setCommunitiesLoadingStatus(false));
  }
};

export const deleteCommunity = (id: string) => async (dispatch: TypedDispatch) => {
  try {
    dispatch(setAuthLoading(true));
    const response = await deleteCommunityRequest(id);

    dispatch(setNotification(response?.data?.message));

    return response?.status;
  } finally {
    dispatch(setAuthLoading(false));
  }
};

export const editCommunity =
  (name: string, id: string, delta: number, companyId: string) =>
  async (dispatch: TypedDispatch) => {
    try {
      dispatch(setAuthLoading(true));
      const response = await editCommunityRequest(name, id, delta, companyId);

      dispatch(setNotification(response?.data?.message));

      return response?.status;
    } finally {
      dispatch(setAuthLoading(false));
    }
  };

export const createCommunity =
  (name: string, delta: number) =>
  async (dispatch: TypedDispatch, getState: () => AppRootStateType) => {
    try {
      dispatch(setAuthLoading(true));
      const response = await createCommunityRequest(name, delta);

      addCommunityToLocalAdmin(response?.data);
      if (getState().auth.user.role === Roles.LOCAL_ADMIN) {
        const newUserInfo = {
          ...getState().auth.user,
          communities: [
            ...getState().auth.user.communities,
            { id: response?.data.id, name: response?.data.name },
          ],
        };

        dispatch(setUserInfo(newUserInfo));
      }

      return response?.status;
    } finally {
      dispatch(setAuthLoading(false));
    }
  };
